import { GRAPHQL_TYPENAMES } from 'modules/graphql/types';
import { ListReference } from 'modules/legacySegmentation/domain';
import { getLabelByMedium } from 'utils/messageMediums';

import { Cell } from './table';
import { TABLE_COLUMNS } from './constants';
import { PlaceholderText } from './PlaceholderText';

type ListReferenceMessageMediumCellProps = {
  listReference: ListReference;
  rowIndex: number;
};

const MEDIUM_CELL_DATA_TEST = 'list-usage-medium-cell';
const MEDIUM_TEXT_DATA_TEST = 'list-usage-medium-text';

export const ListReferenceMessageMediumCell = ({
  listReference: dependent,
  rowIndex,
}: ListReferenceMessageMediumCellProps) => (
  <Cell data-test={MEDIUM_CELL_DATA_TEST} columnId={TABLE_COLUMNS.MEDIUM} rowIndex={rowIndex}>
    {dependent.__typename === GRAPHQL_TYPENAMES.CAMPAIGN ? (
      <div data-test={MEDIUM_TEXT_DATA_TEST}>{getLabelByMedium(dependent.messageMedium)}</div>
    ) : (
      <PlaceholderText>N/A</PlaceholderText>
    )}
  </Cell>
);
